import { useState } from 'react';

import Button from '~components/Button/Button';
import FormDisclaimer from '~components/FormDisclaimer/FormDisclaimer';
import Modal from '~components/ModalDialog/ModalDialog';
import { fireTrackEvent } from '~globals/tracking';
import icon from '~images/badges/calendar_icon.svg';
import success from '~images/badges/check_blue_success.svg';

import EmailLeadForm from '../EmailLeadForm/EmailLeadForm';

type Props = {
    buttontext?: string;
    cta?: string;
    formheader?: string;
    onpageheader?: string;
    qavalue?: string;
    sectiontracking?: string;
    uid: string;
};

const EnrollmentReminderModal = ({
    buttontext = 'Get Reminder',
    cta = 'Remind Me',
    formheader = 'Under 65? Get Your Enrollment Reminder',
    onpageheader = "Under 65? Don't miss your initial enrollment period.",
    qavalue = 'ReminderModalButton',
    sectiontracking = '',
    uid,
}: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const handleClick = () => {
        fireTrackEvent({ page: { action: `${sectiontracking}: enrollment reminder` } });
        setIsOpen(true);
    };

    return (
        <>
            <div className="flex items-center">
                <img src={icon} alt="" width="80" height="80" className="mr-4" />
                <div>
                    <h4 className="font-bold text-xl">{onpageheader}</h4>
                    <Button styletype="link" data-qa={qavalue} onClick={handleClick}>
                        {buttontext}
                    </Button>
                </div>
            </div>

            <Modal isOpen={isOpen} setIsOpen={setIsOpen} title={formheader}>
                <div className="max-w-xl lg:min-w-96">
                    {!isSuccess ? (
                        <>
                            <p className="text-lg text-left">
                                Don&apos;t miss your initial enrollment&nbsp;period!
                            </p>
                            <div className="my-6">
                                <EmailLeadForm
                                    buttonText={cta}
                                    isStacked={true}
                                    leadInfo={{ advertiseSource: 'NTMRemind' }}
                                    leadTrackingAction={{
                                        page: { action: 'enrollment-reminder' },
                                    }}
                                    mktoFormId={1006}
                                    onSuccess={() => setIsSuccess(true)}
                                    uid={uid}
                                    useBirthdate={true}
                                />
                            </div>
                            <FormDisclaimer />
                        </>
                    ) : (
                        <>
                            <img src={success} alt="" width="100" className="mb-4 mx-auto" />
                            <h4 className="text-center text-3xl font-bold mb-8">Success!</h4>
                            <p className="text-center">Your enrollment reminder has been sent!</p>
                            <div className="w-full py-4 flex justify-center">
                                <Button
                                    className="w-full md:w-1/2"
                                    onClick={() => setIsOpen(false)}
                                >
                                    Close
                                </Button>
                            </div>
                        </>
                    )}
                </div>
            </Modal>
        </>
    );
};

export default EnrollmentReminderModal;
